import { create } from 'zustand';

interface MesState {
  isScannerOpen: boolean;
  setScannerOpen: (open: boolean) => void;
  
  isManualAddOpen: boolean;
  setManualAddOpen: (open: boolean) => void;

  selectedRoutingStepId: string | null;
  setSelectedRoutingStepId: (id: string | null) => void;

  activeSessionLogId: string | null;
  setActiveSessionLogId: (id: string | null) => void;

  selectedMachineId: string | null;
  setSelectedMachineId: (id: string | null) => void;
}

export const useMesStore = create<MesState>((set) => ({
  isScannerOpen: false,
  setScannerOpen: (open) => set({ isScannerOpen: open }),
  
  isManualAddOpen: false,
  setManualAddOpen: (open) => set({ isManualAddOpen: open }),

  selectedRoutingStepId: null,
  setSelectedRoutingStepId: (id) => set({ selectedRoutingStepId: id }),

  activeSessionLogId: null,
  setActiveSessionLogId: (id) => set({ activeSessionLogId: id }),

  selectedMachineId: null,
  setSelectedMachineId: (id) => set({ selectedMachineId: id }),
}));
